import { Observable, of } from 'rxjs';

import { Injectable } from '@angular/core';

import { HealthFinding } from '../../beans/health-summary/health-summary.module.bean';
import { Config } from '../../config/config';
import { Environment } from '../../config/environment';
import { METHOD_TYPE } from '../../constants/service.constants';
import { Lookup, RecordReleasePdf, RecordsReleaseRequest } from '../../modules/health-record/record-release.type';
import { ServiceRouter } from '../core/http-service-router.service';
import { JwtHelper } from '../core/jwt-helper.service';

@Injectable({
	providedIn: 'root',
})
export class HealthRecordService {
	constructor(
		private serviceRouter: ServiceRouter,
		private environment: Environment,
		private config: Config,
		private jwtService: JwtHelper
	) {}

	getAuthorizationPurpose(): Observable<Lookup[]> {
		/* return this.serviceRouter.makeRequest(
			'https://' + this.environment.getEnvironment().CONSENT_URL,
			this.config.url.healthRecord.getAuthorizationPurpose,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().CONSENT_URL,
			this.environment.getEnvironment().CONSENT_DOMAIN
		); */
		return of([
			{
				id: 1,
				name: 'At my request',
				description: 'At my request',
			},
			{
				id: 2,
				name: 'Legal reason',
				description: 'Legal reason',
			},
			{
				id: 3,
				name: 'Change of provider/physician',
				description: 'Change of provider/physician',
			},
			{
				id: 4,
				name: 'Other',
				description: 'Other',
			},
		]);
	}

	getHealthDocuments(): Observable<HealthFinding> {
		const self = this;
		return self.serviceRouter.makeRequest(
			this.environment.getEnvironment().EPMS_PROXY_BASE_URL,
			self.config.url.healthRecord.getHealthDocuments,
			METHOD_TYPE.SECURED_GET,
			''
		);
	}

	getInclusions(): Observable<Lookup[]> {
		/* return this.serviceRouter.makeRequest(
			'https://' + this.environment.getEnvironment().CONSENT_URL,
			this.config.url.healthRecord.getInclusions,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().CONSENT_URL,
			this.environment.getEnvironment().CONSENT_DOMAIN
		); */
		return of([
			{
				id: 1,
				name: 'Psychotherapy Notes',
				description: 'Psychotherapy Notes',
			},
			{
				id: 2,
				name: 'HIV-related Treatment',
				description: 'HIV-related Treatment',
			},
			{
				id: 3,
				name: 'Sexually Transmitted Illnesses (STIs)',
				description: 'Sexually Transmitted Illnesses (STIs)',
			},
			{
				id: 4,
				name: 'Alcohol/Substance Abuse Treatment/Referral',
				description: 'Alcohol/Substance Abuse Treatment/Referral',
			},
			{
				id: 5,
				name: 'Mental Health Treatment (Other than Psychotherapy Notes)',
				description: 'Mental Health Treatment (Other than Psychotherapy Notes)',
			},
		]);
	}

	getRecordConsents(): Observable<RecordReleasePdf[]> {
		return this.serviceRouter.makeRequest(
			'https://' + this.environment.getEnvironment().CONSENT_URL,
			this.config.url.healthRecord.getRecordReleases + `?epmsPID=${this.jwtService.getEpmsId()}`,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().CONSENT_URL,
			this.environment.getEnvironment().CONSENT_DOMAIN
		);
	}

	getSharingMethods(): Observable<Lookup[]> {
		/* return this.serviceRouter.makeRequest(
			'https://' + this.environment.getEnvironment().CONSENT_URL,
			this.config.url.healthRecord.getSharingMethods,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().CONSENT_URL,
			this.environment.getEnvironment().CONSENT_DOMAIN
		); */
		return of([
			{
				id: 1,
				name: 'Secure Email',
				description: 'Secure Email',
			},
			{
				id: 2,
				name: 'US Mail',
				description: 'US Mail',
			},
			{
				id: 3,
				name: 'Fax',
				description: 'Fax',
			},
		]);
	}

	getStates(): Observable<any> {
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().EPMS_PROXY_BASE_URL,
			this.config.url.schedulingApi.getStates,
			METHOD_TYPE.SECURED_GET,
			''
		);
	}

	submitRecordRelease(data: RecordsReleaseRequest): Observable<any> {
		data.epmsPID = this.jwtService.getEpmsId();
		data.source = 'MYEHE';

		return this.serviceRouter.makeRequest(
			'https://' + this.environment.getEnvironment().CONSENT_URL + this.environment.getEnvironment().CONSENT_DOMAIN,
			this.config.url.healthRecord.submitRecordRelease + `?epmsPID=${this.jwtService.getEpmsId()}`,
			METHOD_TYPE.SECURED_POST,
			data,
			this.environment.getEnvironment().CONSENT_URL,
			this.environment.getEnvironment().CONSENT_DOMAIN
		);
	}
}
